// extracted by mini-css-extract-plugin
export default {"project__item":"ProjectsList_project__item__8D+6Z","projects__list":"ProjectsList_projects__list__rxSEX"};